import { createFileRoute } from '@tanstack/react-router';

import { StoragePage } from '../../pages/settings';

export const Route = createFileRoute('/_shell/settings/storage')({
  component: StoragePage,
});
